let infoItemOne = {
  header: "Symptom Filter",
  link: "symptom-filter",
  img:
    "https://leafly-cms-production.imgix.net/wp-content/uploads/2020/02/03083523/how-to-find-the-right-cannabis-doctor.jpg",
  content: [
    { type: "h3", text: "About Symptom Filter" },
    {
      type: "p",
      text:
        "The need for medicinal marajuana is vast and finding the right flower to remedy those needs can be hard if one hasn't experienced many options. Med Cabinet believes shopping for flower shouldn't take rocket science. Finding your flower is as easy as telling us what you want to treat. Symptom Filter helps connect you to the right flower you're aching for.",
    },
  ],
};
let infoItemTwo = {
  header: "Advanced A.I. Strain Finder",
  link: "strain-finder",
  img:
    "https://cannabisnewsbox.com/wp-content/uploads/2019/09/Marijuana-technology.jpg",
  content: [
    { type: "h3", text: "About Advanced A.I. Strain Finder" },
    {
      type: "p",
      text:
        "Indica, Sativa, or Hybrid? Just know the flavor you're looking for? No problem!",
    },
    {
      type: "p",
      text:
        "Med Cabinet has gathered the best in Data Science to bring not only options, but customized strain options to fix your craving. Our Advanced A.I. Strain Finder helps connect you to the right flower you're aching for.",
    },
  ],
};
let infoItemThree = {
  header: "Dose Tracker",
  link: "dose-tracker",
  img:
    "https://bloximages.newyork1.vip.townnews.com/wdel.com/content/tncms/assets/v3/editorial/a/0f/a0f330be-cd21-5c1a-8511-5f704e51b90a/5a68b53bdc312.image.jpg?resize=400%2C200",
  content: [
    { type: "h3", text: "About Dose Tracker" },
    {
      type: "p",
      text: "Do you remember your last dosage? We do!",
    },
    {
      type: "p",
      text:
        "With dosage tracker you can track how much you are using and when. Dosage Tracker will even remind you when to order more based on your average consumtion and shopping habits.",
    },
    {
      type: "p",
      text: "Item comming soon!",
    },
  ],
};

let content = {
  infoItemOne: infoItemOne,
  infoItemTwo: infoItemTwo,
  infoItemThree: infoItemThree,
};

export default content;
